import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  public addItem(key: string, value: string): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public getItem(key: string): any {
    const value = localStorage.getItem(key);

    try {
      return value ? JSON.parse(value) : value;
    } catch (e) {
      // console.error('Error parsing JSON', e);
      return value; // Return the raw value if it isn't JSON
    }
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public clearItems() {
    localStorage.clear();
  }

}
